export enum EventFeature {
  PREMIUM_DESIGN_TOOLS = 'premium-design-tools',
  ADS = 'ads',
  GUESTS_OF_HONOR = 'guests-of-honor',
  WHAT_TO_BRING = 'what-to-bring',
  POLLS = 'polls',
  ADDITIONAL_LINKS = 'additional-links',
  HOST_PHOTO_GALLERY = 'host-photo-gallery',
  PHOTO_SHARING = 'photo-sharing',
  RSVPS = 'rsvps',
  GIFT_IDEAS = 'gift-ideas',
  CHARITY = 'charity',
  CROWDFUNDING = 'crowdfunding',
  WISHLIST = 'wishlist',
}
